import { rdc } from '@saucelabs/sl-util-axios';
import config from '@saucelabs/sl-util-config';
import TestObjectClient from '@saucelabs/web-rdc-client';
import truncateMiddle from 'truncate-middle';

const handleResponse = ({ data }) => {
  if (data.status === 'ERROR') {
    throw data.error;
  }

  return data;
};

export const fetchDevice = ({ deviceId }) => rdc.get(`/devices/augmented/${deviceId}`)
  .then(({ data }) => data);

export const connectDevice = ({
  deviceSessionId,
  elementId,
  webRtcEnabled,
  webRtcCredentials,
}) => {
  const rdcApiUrl = config.apiBaseUrls.rdc;
  const cdnUrl = config.saucelabsCdnRoot;
  return TestObjectClient.connectDevice(
    cdnUrl,
    rdcApiUrl,
    deviceSessionId,
    elementId,
    undefined, // hardwareButtonsRatio
    undefined, // pasteEnabled,
    webRtcEnabled,
    webRtcCredentials,
  );
};

export const createNativeAppSession = ({
  deviceId,
  appId,
  groupId,
  tunnel,
  webRtcEnabled,
}) => (
  rdc
    .post(`/manual/devices/${deviceId}/openWithNativeApp`, {
      appStorageAppId: appId,
      appStorageGroupId: groupId,
      tunnel,
      webRtcEnabled,
    })
    .then(handleResponse)
);

export const createBrowserSession = ({
  deviceId,
  testReportName,
  tunnel,
  webRtcEnabled,
}) => {
  // special case for RDC web session where we need to trim the name in the middle
  // due to we're "open"ing the device first before calling "openURL"
  // and the default test name will be set in the "open" call
  let defaultTestReportName = testReportName;
  if (testReportName?.length > 255) {
    defaultTestReportName = truncateMiddle(testReportName, 126, 126, '...');
  }

  return rdc
    .post(`/manual/devices/${deviceId}/open`, {
      testReportName: defaultTestReportName,
      tunnel,
      webRtcEnabled,
    })
    .then(handleResponse);
};

export const takeScreenshot = (deviceSessionId) => (
  rdc.get(`/manual/sessions/${deviceSessionId}/screenshot`, {
    responseType: 'blob',
  })
);
